export const NEXTCLOUD_OPEN_EVENT = 'maater-nextcloud-open'

export type NextcloudOpenDetail = {
  organizationId: string
  path: string
  kind: 'file' | 'folder'
  name: string
  fileId?: string | null
  encrypted?: boolean
  /** Folder open: select this child and show it in the right preview. */
  previewPath?: string
  /** `document` is the single-file view. Sidebar file clicks use it. Preview stays a menu action. */
  surface?: 'browse' | 'document'
  /** History restore. Updates the sidebar selection without recording another step. */
  selectOnly?: boolean
}

export function dispatchNextcloudOpen(detail: NextcloudOpenDetail) {
  window.dispatchEvent(new CustomEvent(NEXTCLOUD_OPEN_EVENT, { detail }))
}
